import * as yup from 'yup'
import { parseDateString } from './foiSchema'

const activitySchema = yup.object().shape({
  label: yup.string().required('Label is required'),
  date: yup.date().transform(parseDateString).typeError('Date must be valid').required('Date is required'),
  time: yup.date().required('Time is required')
})

export { activitySchema }
